module.exports = __webpack_public_path__ + "img/tema-1-11.f93af749.png";